'use client'
import React from 'react'
import { LOCALE_COOKIE, type Locale } from '@/lib/i18n'

// 语言切换：写 Cookie 后整页刷新，服务端按 Cookie 渲染对应语言（URL 不变）
export default function LangToggle({ locale, className = '' }: { locale: Locale; className?: string }) {
    function switchTo(next: Locale) {
        if (next === locale) return
        document.cookie = `${LOCALE_COOKIE}=${next}; path=/; max-age=31536000; samesite=lax`
        location.reload()
    }

    const base = 'cursor-pointer transition-colors duration-200'
    const active = 'font-semibold text-gray-900'
    const inactive = 'text-gray-400 hover:text-gray-600'

    return (
        <span className={`flex items-center gap-2 text-sm select-none ${className}`}>
            <button type="button" onClick={() => switchTo('en')}
                className={`${base} ${locale === 'en' ? active : inactive}`}>
                EN
            </button>
            <span className="h-3 w-px bg-gray-300" aria-hidden="true" />
            <button type="button" onClick={() => switchTo('zh')}
                className={`${base} ${locale === 'zh' ? active : inactive}`}>
                中
            </button>
        </span>
    )
}
